import React, { useState } from "react";
import { blurBg, iButton } from "../assets/img";
import { useAppContext } from "../Services/AppContext";
import useStore from "./redux/store/useStore";

const Holiday = () => {
  const [info, setInfo] = useState(false);
  const { holiday } = useStore();

  const ReasonData = localStorage.getItem("reason");

  const Reason = holiday?.reason || ReasonData;

  return (
    <div
      className="holiday-container"
      style={{ backgroundImage: `url(${blurBg})` }}
    >
      <div className="holiday-blur">
        <h2 className="holiday-text">
          HOLIDAY{" "}
          <button
            className="info-btn"
            onClick={() => setInfo(!info)}
            aria-label="Info"
          >
            <img src={iButton} alt="info" className="info-icon" />
          </button>
        </h2>

        {info && (
          <div className="info-popup">
            <p>{Reason || "No holiday reason provided."}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Holiday;
